import React from 'react';
import { Options, formatMediumDate, useTranslator } from '@front-activerse/common-components';

interface Props {
  start: string;
  end: string;
  t: (message: string, options?: Options) => string;
}

const PeriodInfo: React.FC<Props> = ({ start, end }) => {
  const { t } = useTranslator();
  return (
    <div className="text-center mb-xl">
      <p className="title-small mb-0">{t('shoppingList.period.title')}</p>
      <p className="title-small mt-xxs">
        {t('shoppingList.period.fromDate')}&nbsp;
        <span className="semi-bold">{formatMediumDate(start)} </span>
        {t('shoppingList.period.toDate')}&nbsp;
        <span className="semi-bold">{formatMediumDate(end)}</span>
      </p>
    </div>
  );
};

export default PeriodInfo;
